import GrupoModuloService from "../../services/GrupoModuloService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormGrupoModulo from "../../pages/GrupoModulo/FormGrupoModulo";
import Permissao from "../../controllers/Permissao";

export default class SelectGrupoModulo extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(45));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de Grupo Módulo',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormGrupoModulo,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idGrupoModulo) {
                        this.handleOpenSearch(null, response.data?.idGrupoModulo);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        GrupoModuloService.getForCombo((response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}